import { GAME_ID, REDUX_ACTIONS, SCREENS } from 'a/allAboard/data/constants';
import { getLevelCount } from 'a/allAboard/redux/reducers/curriculumSelectors';

const createInitialArrays = () => {
  const levelCount = getLevelCount();
  const ArrayLengthOfLevels = Array(levelCount);
  const ArrayLengthOfLevelsFalse = [...ArrayLengthOfLevels].fill(false);
  const ArrayLengthOfLevelsZero = [...ArrayLengthOfLevels].fill(0);

  return {
    levelsMastered: ArrayLengthOfLevelsFalse,
    contentSideFlagsByLevel: ArrayLengthOfLevelsZero,
  };
};

const initialState = {
  levelsMastered: [], // Will be initialized when curriculum is loaded
  contentSideFlagsByLevel: [], // Will be initialized when curriculum is loaded
  isOnboardingComplete: false, // Keeps track of if user has completed phoneme onboarding in this session
  hasSeenPassengerOnboarding: false, // Keeps track of if user has seen a level with passengers in this session
  hasSeenDualTrackOnboarding: false, // Keeps track of if user has seen a dual track / split track level in this session
  didOnboardFromLevel: false, // Did the user onboard by clicking play or a  level (true) or did they click the help button (false)
  selectedLevelIndex: 0,
};

// Reducer to keep track of game wide (all levels) data

const gameDetailsReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.CHANGE_SCREEN: {
      // Initialize levelsMastered, contentSideFlagsByLevel arrays after initial curriculum load
      if (payload === SCREENS.PROGRESS && state.levelsMastered.length === 0) {
        const initialArrays = createInitialArrays();
        return {
          ...state,
          ...initialArrays,
        };
      }
      return state;
    }
    case REDUX_ACTIONS.MARK_PASSENGER_ONBOARDING_AS_SEEN:
      return {
        ...state,
        hasSeenPassengerOnboarding: true,
      };
    case REDUX_ACTIONS.MARK_DUAL_TRACK_ONBOARDING_AS_SEEN:
      return {
        ...state,
        hasSeenDualTrackOnboarding: true,
      };
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnboardingComplete: payload.isOnboardingComplete,
      };
    case REDUX_ACTIONS.SELECT_LEVEL:
      return {
        ...state,
        selectedLevelIndex: payload,
      };
    case REDUX_ACTIONS.UPDATE_LEVEL_CONTENT:
      return {
        ...state,
        levelsMastered: payload.levelsMastered,
        contentSideFlagsByLevel: payload.contentSideFlagsByLevel,
        selectedLevelIndex: payload.selectedLevelIndex,
      };
    case REDUX_ACTIONS.INIT_ONBOARDING: {
      return {
        ...state,
        didOnboardFromLevel: payload.didOnboardFromLevel,
      };
    }
    default:
      return state;
  }
};

export default gameDetailsReducer;
